const clinicalPurpose = [
  "Screen result is inconsistent with patient’s self-report, presentation, medical history, or current prescribed medication plan.",
  "Definitive concentration of drug is clinically necessary to guide patient care management.",
  "Identify specific drugs in a large family of drugs.",
  "Suspected use of substance either not detected or inadequately detected by presumptive testing presumptive result.",
  "Rule out error as the cause of a negative.",
];

export default clinicalPurpose;
